(function () {
  'use strict';

  var hasReloaded = false;
  var drawerWasOpen = false;

  function refreshPageOnce() {
    if (hasReloaded) {
      return;
    }

    hasReloaded = true;
    window.location.reload();
  }

  function watchCartDrawer(drawer) {
    if (!drawer) {
      return;
    }

    drawerWasOpen = drawer.hasAttribute('open');

    new MutationObserver(function () {
      var isOpen = drawer.hasAttribute('open');

      if (!isOpen && drawerWasOpen) {
        refreshPageOnce();
      }

      drawerWasOpen = isOpen;
    }).observe(drawer, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  function init() {
    var drawer = document.querySelector('cart-drawer#mini-cart');

    if (drawer) {
      watchCartDrawer(drawer);
    } else {
      new MutationObserver(function (_mutations, observer) {
        drawer = document.querySelector('cart-drawer#mini-cart');

        if (drawer) {
          observer.disconnect();
          watchCartDrawer(drawer);
        }
      }).observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
